import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './slider.module.scss';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';

const SLIDE_IMAGES: Array<string> = [
  '/images/collaborations/dva-myacha-peppershtein/slide1.jpeg',
  '/images/collaborations/dva-myacha-peppershtein/slide2.jpeg',
  '/images/collaborations/dva-myacha-peppershtein/slide3.jpeg',
  '/images/collaborations/dva-myacha-peppershtein/slide4.jpeg',
  '/images/collaborations/dva-myacha-peppershtein/slide5.jpeg',
];

SwiperCore.use([Navigation]);
export const Slider = (): JSX.Element => {
  return (
    <div className={styles.slider}>
      <Swiper navigation draggable={false} speed={1}>
        {SLIDE_IMAGES.map((img: string) => (
          <SwiperSlide key={img}>
            <div className={styles.slide}>
              <img src={img} className={styles['slide-back']} alt="img" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
